import type { ServiceAuthFactory } from "../../../services/auth/types";
import { EngageAuthAdapter } from "./adapter";

export const engageAuthFactory: ServiceAuthFactory = {
  addinKey: "engage",
  create(cfg, deps) {
    return new EngageAuthAdapter(cfg, deps);
  },
};
